var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Madagascar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M15,6.157C8.48,9.453,4,16.195,4,24c0,7.804,4.48,14.547,11,17.843V24V6.157z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M15,41.843C17.708,43.212,20.759,44,24,44c11.046,0,20-8.954,20-20H15V41.843z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M15,24h29c0-11.046-8.954-20-20-20c-3.241,0-6.292,0.788-9,2.157V24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Madagascar);
export default __webpack_public_path__ + "static/media/icons8-madagascar.f65685a3c33acc7310b0e66ad9f974df.svg";
export { ForwardRef as ReactComponent };